import { RefObject } from 'react';

export enum PartialDateTimeIgnore {
    Nothing = 'Nothing',
    IgnoreTime = 'IgnoreTime',
    IgnoreDay = 'IgnoreDay',
}

export enum PartialDateTimeIgnoreNumeric {
    Nothing,
    IgnoreTime = 1,
    IgnoreDay = 2,
}

export enum CategoryType {
    Site = 0,
    Subject = 1,
    Data = 2,
}

export interface StudyFilterProps {
    'data-testid': string;
    categories: Array<FilterCategory>;
    onApply: () => void;
    datasetId?: number;
    studyRef: string;
    dataViewRef?: string;
    defaultCategory?: Pick<ChipData, 'parentCategory' | 'categoryId'> | null;
    onClose: () => void;
    filterChipElements: RefObject<Map<number, HTMLElement>>;
}

export interface StudyDataFilterHandle {
    setSelectedCategory: (parentCategory: CategoryType, categoryId: number) => void;
}

export type FilterCategory = {
    id: CategoryType;
    items: Array<FilterCategoryItems>;
};

export type ChipData = {
    parentCategory: CategoryType;
    parentName: string;
    categoryId: number;
    category: string;
    index: number;
};

export type PrimitiveValues = number | string | Date | boolean | null;

export type FilterValue = {
    id: number;
    label: string;
    disabled?: boolean;
    value: unknown;
    dateTimeIgnore?: PartialDateTimeIgnoreNumeric;
};

export type FilterCategoryItems = {
    id: number;
    label: string;
    isDefault: boolean;
    index: number;
    dataType: FieldDefinitionFieldTypeNumeric;
    context: RowDataSourceTableNumeric;
    fieldKey: string;
};

export enum RowDataSourceTableNumeric {
    Study = 1,
    Site = 2,
    SiteVisit = 3,
    SiteIssue = 4,
    SiteProtocolDeviation = 5,
    Subject = 6,
    SubjectAdverseEvent = 7,
    SubjectAssessment = 8,
    SubjectCrf = 9,
    SubjectInformedConsent = 10,
    SubjectIssue = 11,
    SubjectLab = 12,
    SubjectProtocolDeviation = 13,
    SubjectQuery = 14,
    SubjectVisit = 15,
    SubjectConcomitantMedication = 16,
    SubjectMedicalHistory = 17,
}

export enum FieldDefinitionFieldTypeNumeric {
    Text = 0,
    Date = 1,
    PartialDate = 2,
    Int = 3,
    Float = 4,
    Bool = 5,
    Undefined = 6,
    Long = 7,
    CSV = 8,
}

export enum FilterUIConfigType {
    DataView = 1,
    StudyDashboard = 2,
    SubjectMonitoringHub = 3,
}
